import moment from 'moment';
// import config from '../config';
import queryApi from './api/queryApi';
import SearchRecommendApi from './api/searchRecommendApi';
/* ACTIONS */

export const OPENSEARCH_FIRSTCLICKRANKING = 'OPENSEARCH/FIRSTCLICKRANKING';
export const OPENSEARCH_TOP10PURCHASECONTENT = 'OPENSEARCH/TOP10PURCHASECONTENT';
export const OPENSEARCH_TOP10RENTCONTENT = 'OPENSEARCH/TOP10RENTCONTENT';
export const OPENSEARCH_TOP10SHARECONTENT = 'OPENSEARCH/TOP10SHARECONTENT';
export const OPENSEARCH_TOP10DOWNLOADCONTENT = 'OPENSEARCH/TOP10DOWNLOADCONTENT';
export const OPENSEARCH_TOP10ADDWATCHLISTCONTENT = 'OPENSEARCH/TOP10ADDWATCHLISTCONTENT';
export const OPENSEARCH_TOP10DELETEWATCHLISTCONTENT = 'OPENSEARCH/TOP10DELETEWATCHLISTCONTENT';
export const OPENSEARCH_TOP10MOVIETRAILER = 'OPENSEARCH/TOP10MOVIETRAILER';
export const OPENSEARCH_TOP10SERIESTRAILER = 'OPENSEARCH/TOP10SERIESTRAILER';



export const SPICONFIG_LIST = 'SPICONFIG/LIST';
export const SPICONFIG_UPDATE = 'SPICONFIG/UPDATE';


export const VIEWERSESSION_SETTINGS = 'VIEWERSESSION/SETTINGS';
export const VIEWERSESSION_GETLIST = 'VIEWERSESSION/GETLIST';
export const VIEWERSESSION_GETUSERLIST = 'VIEWERSESSION/GETUSERLIST';
export const VIEWERSESSION_GETFILTERLIST = 'VIEWERSESSION/GETFILTERLIST';
export const VIEWERSESSION_GETSESSIONLIST = 'VIEWERSESSION/GETSESSIONLIST';
export const VIEWERSESSION_GETERRORLIST = 'VIEWERSESSION/GETERRORLIST';
export const INSPECTIONTIME_UPDATE = 'INSPECTIONTIME/UPDATE';
export const INDEPTHFILTER_UPDATE = 'INDEPTHFILTER/UPDATE';

/* ROUTE API */
// const SPICONFIG_LIST_ROUTE = '/broadcast';

const initialState = {
	viewersessionSettings: {userAccount: "",maxStep:0, currentStep: 0, timerange:[moment().startOf('hour').add(-1,'days').add(1,'hour').toISOString(), moment().startOf('hour').add(1,'hour').toISOString()]},
	inspectionTime: {day:7, till:moment().add(1,'hour').startOf('hour').toISOString()}
};

const getOpenSearchBuckets = (data) => {
	if(data && data.responses && data.responses[0] && data.responses[0].aggregations && data.responses[0].aggregations.results && data.responses[0].aggregations.results.buckets){
		return data.responses[0].aggregations.results.buckets;
	}else{
		return [];
	}
}



export default (state = initialState, action) => {
	switch (action.type) {
		case SPICONFIG_LIST:
			return {
				...state,
				spiconfigList: action.payload,
			};
		case SPICONFIG_UPDATE: // WHENEVER THAT IS UPDATED
			return {
				...state,
				spiCDNList: null
			};
		case INSPECTIONTIME_UPDATE:
			delete state.spiCDNList;
			delete state.indepthFilter;
			delete state.viewersessionFilterList;
			delete state.opensearchFisrtClickList;
			delete state.opensearchTop10PurchaseContentList;
			delete state.opensearchTop10RentContentList;
			delete state.opensearchTop10ShareContentList;
			delete state.opensearchTop10DownloadContentList;
			delete state.opensearchTop10AddWatchlistContentList;
			delete state.opensearchTop10DeleteWatchlistContentList;
			delete state.opensearchTop10MovieTrailerList;
			delete state.opensearchTop10SeriesTrailerList;

			return {
				...state,
				inspectionTime: action.payload,
			};
		case VIEWERSESSION_SETTINGS:
			return {
				...state,
				viewersessionSettings: action.payload
			};
		case VIEWERSESSION_GETLIST:
			return {
				...state,
				viewersessionList: action.payload
			};
		case VIEWERSESSION_GETUSERLIST:
			return {
				...state,
				viewersessionUserList: action.payload,
			};
		case VIEWERSESSION_GETFILTERLIST:
			return {
				...state,
				viewersessionFilterList: action.payload,
			};
		case VIEWERSESSION_GETSESSIONLIST:
			return {
				...state,
				viewersessionSessionList: action.payload,
			};
		case VIEWERSESSION_GETERRORLIST:
			return {
				...state,
				viewersessionErrorList: action.payload,
			};
		case OPENSEARCH_FIRSTCLICKRANKING:
			return {
				...state,
				opensearchFisrtClickList: action.payload,
			};
		case OPENSEARCH_TOP10PURCHASECONTENT:
			return {
				...state,
				opensearchTop10PurchaseContentList: action.payload,
			};
		case OPENSEARCH_TOP10RENTCONTENT:
			return {
				...state,
				opensearchTop10RentContentList: action.payload,
			};
		case OPENSEARCH_TOP10SHARECONTENT:
			return {
				...state,
				opensearchTop10ShareContentList: action.payload,
			};
		case OPENSEARCH_TOP10DOWNLOADCONTENT:
			return {
				...state,
				opensearchTop10DownloadContentList: action.payload,
			};
		case OPENSEARCH_TOP10ADDWATCHLISTCONTENT:
			return {
				...state,
				opensearchTop10AddWatchlistContentList: action.payload,
			};
		case OPENSEARCH_TOP10DELETEWATCHLISTCONTENT:
			return {
				...state,
				opensearchTop10DeleteWatchlistContentList: action.payload,
			};
		case OPENSEARCH_TOP10MOVIETRAILER:
			return {
				...state,
				opensearchTop10MovieTrailerList: action.payload,
			};
		case OPENSEARCH_TOP10SERIESTRAILER:
			return {
				...state,
				opensearchTop10SeriesTrailerList: action.payload,
			};
		
		default:
			return state;
	}
};

export const spiconfigGetList = (organization) => {
	return dispatch => {
		return queryApi.get(`/statistic/performanceConfig?account=${organization}`).then(data => {
			dispatch({
				type: SPICONFIG_LIST,
				payload: data
			});
			
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};

export const spiconfigUpdate = (payload, paramStr) => {
	return dispatch => {
		return queryApi.patch(`/statistic/performanceConfig?${paramStr}`, payload).then(data => {
			dispatch({
				type: SPICONFIG_UPDATE
			});
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};




export const indepthFilterUpdate = (data) => {
	return dispatch => {
		dispatch({
			type: INDEPTHFILTER_UPDATE,
			payload: data
		});
	};
};

export const inspectionTimeUpdate = (data) => {
	return dispatch => {
		dispatch({
			type: INSPECTIONTIME_UPDATE,
			payload: data
		});
	};
};

export const viewersessionUpdateSettings = (data) => {
	return dispatch => {
		dispatch({
			type: VIEWERSESSION_SETTINGS,
			payload: data
		});
	};
};

export const viewersessionGetList = (paramStr) => {
	return dispatch => {
		return queryApi.get(`/statistic/listAccountName?${paramStr}`).then(data => {
			dispatch({
				type: VIEWERSESSION_GETLIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};

export const viewersessionGetUserList = (paramStr) => {
	return dispatch => {
		// return api.get(`/analytics?account=${organization}&func=getSPIConfig`).then(data => {
		return queryApi.get(`/statistic/listViewerSession?${paramStr}`).then(data => {
			dispatch({
				type: VIEWERSESSION_GETUSERLIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};

export const viewersessionGetFilterList = (paramStr) => {
	return dispatch => {
		// return api.get(`/analytics?account=${organization}&func=getSPIConfig`).then(data => {
		return queryApi.get(`/statistic/listViewerSession?${paramStr}`).then(data => {
			dispatch({
				type: VIEWERSESSION_GETFILTERLIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};

export const viewersessionGetSessionList = (paramStr) => {
	return dispatch => {
		// return api.get(`/analytics?account=${organization}&func=getSPIConfig`).then(data => {
		return queryApi.get(`/statistic?${paramStr}`).then(data => {
			dispatch({
				type: VIEWERSESSION_GETSESSIONLIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};

export const viewersessionGetErrorList = (paramStr) => {
	return dispatch => {
		// return api.get(`/analytics?account=${organization}&func=getSPIConfig`).then(data => {
		return queryApi.get(`/statistic/listErrorSession?${paramStr}`).then(data => {
			dispatch({
				type: VIEWERSESSION_GETERRORLIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};

export const opensearchFiratClickRanking = (paramStr) => {
	return dispatch => {
		return SearchRecommendApi.get(`/query?${paramStr}&type=getFirstClickRanking`).then(data => {
			dispatch({
				type: OPENSEARCH_FIRSTCLICKRANKING,
				payload: getOpenSearchBuckets(data)
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};
export const opensearchTop10PurchaseContent = (paramStr) => {
	return dispatch => {
		return SearchRecommendApi.get(`/query?${paramStr}&type=getTop10PurchaseContent`).then(data => {
			dispatch({
				type: OPENSEARCH_TOP10PURCHASECONTENT,
				payload: getOpenSearchBuckets(data)
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};
export const opensearchTop10RentContent = (paramStr) => {
	return dispatch => {
		return SearchRecommendApi.get(`/query?${paramStr}&type=getTop10RentContent`).then(data => {
			dispatch({
				type: OPENSEARCH_TOP10RENTCONTENT,
				payload: getOpenSearchBuckets(data)
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};
export const opensearchTop10ShareContent = (paramStr) => {
	return dispatch => {
		return SearchRecommendApi.get(`/query?${paramStr}&type=getTop10ShareContent`).then(data => {
			dispatch({
				type: OPENSEARCH_TOP10SHARECONTENT,
				payload: getOpenSearchBuckets(data)
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};
export const opensearchTop10DownloadContent = (paramStr) => {
	return dispatch => {
		return SearchRecommendApi.get(`/query?${paramStr}&type=getTop10DownloadContent`).then(data => {
			dispatch({
				type: OPENSEARCH_TOP10DOWNLOADCONTENT,
				payload: getOpenSearchBuckets(data)
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};
export const opensearchTop10AddWatchlistContent = (paramStr) => {
	return dispatch => {
		return SearchRecommendApi.get(`/query?${paramStr}&type=getTop10AddWatchlistContent`).then(data => {
			dispatch({
				type: OPENSEARCH_TOP10ADDWATCHLISTCONTENT,
				payload: getOpenSearchBuckets(data)
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};
export const opensearchTop10DeleteWatchlistContent = (paramStr) => {
	return dispatch => {
		return SearchRecommendApi.get(`/query?${paramStr}&type=getTop10DeleteWatchlistContent`).then(data => {
			dispatch({
				type: OPENSEARCH_TOP10DELETEWATCHLISTCONTENT,
				payload: getOpenSearchBuckets(data)
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};
export const opensearchTop10MovieTrailer = (paramStr) => {
	return dispatch => {
		return SearchRecommendApi.get(`/query?${paramStr}&type=getTop10MovieTrailer`).then(data => {
			dispatch({
				type: OPENSEARCH_TOP10MOVIETRAILER,
				payload: getOpenSearchBuckets(data)
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};
export const opensearchTop10SeriesTrailer = (paramStr) => {
	return dispatch => {
		return SearchRecommendApi.get(`/query?${paramStr}&type=getTop10SeriesTrailer`).then(data => {
			dispatch({
				type: OPENSEARCH_TOP10SERIESTRAILER,
				payload: getOpenSearchBuckets(data)
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};



